import React from "react";
import {GooglePlayIcon, PCIcon} from "../constants/icons"


export default function GalleryItem({ item }) {
    return (

            <div className="gallery-item">
                <img alt="asd" src={item.image} className="gallery-item-image" />
                <div className="gallery-item-context">
                    <h1 className="gallery-item-context-label">{item.name}</h1>
                    <div className="gallery-item-context-buttons">
                      {item.googlePlayUrl !== "" ? <GooglePlayIcon link={item.googlePlayUrl}/> : <span></span>}
                      {item.pcUrl !== "" ? <PCIcon link={item.pcUrl}/> : <span></span>}
                      
                    </div>
                </div>
            </div>
    );
}
